import styled from 'styled-components';
import { getColor, getSizeBy } from '../../../src/styled/utils';
import { Subtitle1Styles } from '../typography';
const positionValues = { top: '0', center: '50%', bottom: '100%' };
const horizontalPositionValues = { left: '0', center: '50%', right: '100%' };
export const MarkerStyled = styled.div `
  ${Subtitle1Styles}
  position: absolute;
  top: ${({ $position }) => positionValues[$position.vertical] || '0'};
  left: ${({ $position, $inLabel, $wide }) => {
    const horizontal = $position.horizontal;
    if (!$inLabel)
        return horizontalPositionValues[horizontal] || '0';
    if ($wide && horizontal === 'right') {
        return '50px';
    }
    if (horizontal === 'left')
        return '5px';
    if (horizontal === 'right')
        return 'calc(100% - 5px)';
    return '0';
}};
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $wide }) => {
    if ($wide)
        return getSizeBy(6.25);
    return getSizeBy(1.5);
}};
  height: ${({ $wide }) => {
    if ($wide)
        return getSizeBy(2);
    return getSizeBy(1.5);
}};
  background-color: ${({ $color, theme }) => {
    return getColor($color || 'success', 'highEmphasis')({ theme });
}};
  border-radius: ${getSizeBy(0.75)};
  transform: ${({ $position, $wide }) => {
    let translateX = '0';
    let translateY = '0';
    if ($position.vertical === 'center') {
        translateY = '-50%';
    }
    else if ($position.vertical === 'bottom') {
        translateY = '-100%';
    }
    if ($position.horizontal === 'center') {
        translateX = '-50%';
    }
    else if ($position.horizontal === 'right' && $wide) {
        translateX = '-25%';
    }
    else if ($position.horizontal === 'right') {
        translateX = '-100%';
    }
    return `translate(${translateX}, ${translateY})`;
}};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;
